// mediaMessageSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Recipient } from "../interfaces/reducersInterfaces";
import axios from 'axios';
import { addEsChatToConfig } from "../../Utils/apiUtils";

// interface MediaUploadResponse {
//   success: boolean;
//   modified_url: string;
//   authorization_credintial: string;
//   url: string;
//   mime_type: string;
//   sha256: string;
//   file_size: number;
//   id: string;
//   messaging_product: string;
//   message: null;
//   phone_number_id: number;
// }

interface MediaSendParams {
  media_link: string;
  type: string;
  caption: string;
  currentRecipient: Recipient;
  is_schedule?: boolean;
  schedule_type?: "relative" | "specific";
  unit_of_time_name?: string;
  unit_of_time_value?: string;
  schedule_datetime_date?: string;
  time_zone?: string;
  condition_one?: string | null;
  condition_two?: {
    c?: string;
    v?: string[];
  };
  senderUserId?: string | null;
  senderDisplayName?: string | null;
}

interface MediaMessageState {
  isLoading: boolean;
  error: string | null;
}

export const handleMediaSend = createAsyncThunk(
  'mediaMessage/handleMediaSend',
  async ({
    media_link,
    type,
    caption,
    currentRecipient,
    is_schedule,
    schedule_type,
    unit_of_time_name,
    unit_of_time_value,
    schedule_datetime_date,
    time_zone,
    condition_one,
    condition_two,
  }: MediaSendParams) => {
    const captionTrimmed = typeof caption === "string" ? caption.trim() : "";
    // First get media details
    // const retrieveResponse = await axios.post<MediaUploadResponse>(
    //   'https://api.insightssystem.com/api:bVXsw_FD/media/upload', { 
    //     raw_link,
    //     user_id 
    //   },
    // );

    // const { mime_type, id, authorization_credintial, phone_number_id } = retrieveResponse.data;

    // Determine type based on mime_type
    // const type = type

    // Determine endpoint based on mime type
    let endpoint = 'https://api.insightssystem.com/api:bVXsw_FD/web/send/';
    if (type === "image") {
      endpoint += 'image';
    } else if (type === "video") {
      endpoint += 'video';
    }else if (type === "audio") {
      endpoint += 'audio';
    } else {
      endpoint += 'document';
    }

    // Send media with caption
    const config = addEsChatToConfig();
    
    const sendResponse = await axios.post(
      endpoint,
      {
        media_link: media_link,
        caption: captionTrimmed,
        currentRecipient,
        type,
        is_schedule: is_schedule ?? false,
        ...(is_schedule
          ? {
              schedule_type,
              ...(schedule_type === "relative"
                ? {
                    unit_of_time_name,
                    unit_of_time_value,
                  }
                : {
                    schedule_datetime_date,
                    time_zone,
                  }),
              condition_one: condition_one ?? null,
              condition_two: condition_two ?? {},
            }
          : {}),
      },
      config
    );

    return sendResponse.data;
  }
);

const initialState: MediaMessageState = {
  isLoading: false,
  error: null
};

const mediaMessageSlice = createSlice({
  name: 'mediaMessage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(handleMediaSend.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(handleMediaSend.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(handleMediaSend.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to send media';
      });
  }
});

export default mediaMessageSlice.reducer;